import React, {useEffect, useState} from "react";
import {News} from "../../utils/types";
import {supabase} from "../../utils/supabaseClient";
import styles from "./newsBlock.module.css";

const NewsBlock: React.FC = () => {
    const [newsList, setNewsList] = useState<News[]>([]);

    const formatDate = (dateString: string) => {
        const date = new Date(dateString);
        const day = date.getDate();
        const monthNames = [
            'January', 'February', 'March', 'April', 'May', 'June',
            'July', 'August', 'September', 'October', 'November', 'December'
        ];
        const month = monthNames[date.getMonth()];

        return `${month} ${day}`;
    };

    useEffect(() => {
        fetchNews();
    }, []);

    const fetchNews = async () => {
        const { data, error } = await supabase
            .from('news')
            .select('id, created_at, title, image, category')
            .order('created_at', { ascending: false })
            .limit(4);

        if (error) {
            console.error('Error fetching news:', error.message);
        } else {
            setNewsList(data);
        }

    };

    const firstNews = newsList.length > 0 ? newsList[0] : null;
    const remainingNews = newsList.slice(1);

    return (
            <>
                {firstNews && (
                        <div key={firstNews.id} className={styles.main_article}>
                            {firstNews.image && (
                                <img
                                    className={styles.main_article__image}
                                    src={`https://heocxyrunuvilpdfnoib.supabase.co/storage/v1/object/public/news-images/${firstNews.image}`}
                                    alt={firstNews.title}
                                />
                            )}
                            <div className={styles.main_article__data}>
                                <h3>{firstNews.title}</h3>
                                <div>
                                    <span className={styles.main_article__tag}>{firstNews.category}</span>
                                    <span className={styles.main_article__date}>{formatDate(firstNews.created_at)}</span>
                                </div>
                            </div>

                    </div>
                )}
                <div className={styles.articles}>
                    {remainingNews.map((news) => (
                        <div className={styles.article} key={news.id}>
                            <img
                                src={`https://heocxyrunuvilpdfnoib.supabase.co/storage/v1/object/public/news-images/${news.image}`}
                                alt={news.title}
                            />
                            <div className={styles.article__data}>
                                <h4>{news.title}</h4>
                                <div>
                                    <span className={styles.main_article__tag}>{news.category}</span>
                                    <span className={styles.main_article__date}>{formatDate(news.created_at)}</span>
                                </div>
                            </div>
                        </div>
                        ))}
                </div>
            </>
    );
};

export default NewsBlock;
